export const formatCurrencyJP = (amount: number | string): string => {
  const value = typeof amount === 'string' ? Number(amount) : amount
  const priceFormatter = new Intl.NumberFormat('en', {
    style: 'currency',
    currency: 'JPY'
  })

  return Number.isNaN(value) ? '' : priceFormatter.format(value)
}
